import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormGroup from "@material-ui/core/FormGroup";

// Custom Component
import Legend from "../../../Legend/Legend";
import AttachmentChip from "../../../Chip/AttachmentChip";
import FileDropzone from "../../../FileDropzone/WorkflowFileDropzone";
import RFIDraftResponseFileZoneContent from ".././RFIDraftResponseFileZoneContent";
import { ckEditorToolbar } from "../../../../global/ckEditor";

// Custom Style
import { rfiDetailFormStyle } from "../../../../styles/jss/components/RFI/rfiDetailFormStyle";

const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));

const RFIDraftResponseItem = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  // Use redux data
  const submissionRFIDetailRedux = useSelector(
    (state) => state.submissionRFIDetailRedux
  );
  const propertySeqRedux = useSelector((state) => state.propertySeqRedux);

  const {
    rfi_seq,
    saveDraftResponsetoDraftAction,
    postDraftResponseConfirmAction,
    submissionValue,
    setSubmissionValue,
    draftResponseFileUploadAction,
    removeDraftResponseFileConfirmAction,
    viewFileAction,
    openDraftFileManagerDialog,
    draftfileManagerDialogHandleOpen,
    openFileManagerDialog,
    presetDraftResponseFiles,
    obj,
    index,
    response_seq,
    tmpResponseSeq,
    setTmpResponseSeq,
  } = props;

  const [validateError, setValidateError] = useState({
    response_seq: response_seq,
    from: "",
    companyName: "",
    postFlag: false,
  });

  // CKEditor Config
  const editorConfiguration = {
    toolbar: ckEditorToolbar,
  };

  const handleRadioChange = (response_seq) => (event) => {
    const data = { ...submissionValue.draftMessages };
    const targetedIndex = submissionValue.draftMessages.findIndex(
      (obj) => obj.response_seq === response_seq
    );

    data[targetedIndex]["type"] = event.target.value;

    setSubmissionValue({ ...submissionValue, ...data });
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, ...data },
    });
  };

  const handleResponseInputChange = (name, response_seq) => (event) => {
    const data = { ...submissionValue.draftMessages };
    const targetedIndex = submissionValue.draftMessages.findIndex(
      (obj) => obj.response_seq === response_seq
    );
    data[targetedIndex][name] = event.target.value;
    setSubmissionValue({
      ...submissionValue,
      ...data,
    });

    // let validatedata = { ...validateError };
    // if (event.target.value === "") {
    //   validatedata[name] = "This field is required";
    // } else {
    //   validatedata[name] = "";
    // }
    // setValidateError({ ...validateError, ...validatedata });
  };

  // Handle Form Input
  const ckeditorHandleChange = (response_seq) => (event, editor) => {
    const inputData = editor.getData();
    const data = { ...submissionValue.draftMessages };
    const targetedIndex = submissionValue.draftMessages.findIndex(
      (obj) => obj.response_seq === response_seq
    );
    data[targetedIndex].response = inputData;
    setSubmissionValue({ ...submissionValue, ...data });
  };

  useEffect(() => {
    let data = { ...submissionValue.draftMessages };

    data.dms_property_seqs = propertySeqRedux;

    // if (presetSubject !== null) {
    //   data.circ_subject = presetSubject;
    //   setCirculationSubject(presetSubject);
    // }

    if (presetDraftResponseFiles !== null) {
      const targetedIndex = submissionValue.draftMessages.findIndex(
        (obj) => obj.response_seq === tmpResponseSeq
      );
      data[targetedIndex].attachments.push(...presetDraftResponseFiles);
    }

    setSubmissionValue({ ...submissionValue, ...data });
    setTmpResponseSeq(null);
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, data },
    });
  }, [presetDraftResponseFiles]);

  useEffect(() => {
    let data = { ...validateError };
    if (obj.from === null || obj.from === "") {
      data.from = "This field is required";
      setValidateError({ ...validateError, ...data });
    } else {
      data.from = "";
      setValidateError({ ...validateError, ...data });
    }
    if (obj.companyName === null || obj.companyName === "") {
      data.companyName = "This field is required";
      setValidateError({ ...validateError, ...data });
    } else {
      data.companyName = "";
      setValidateError({ ...validateError, ...data });
    }
  }, [obj.from, obj.companyName]);

  return (
    <Fragment>
      <div
        style={{
          display: "flex",
        }}
      >
        <Grid item xs={12}>
          <Typography variant="subtitle1" className={classes.subHeaderText}>
            {`Draft Message #${index + 1}`}
          </Typography>
        </Grid>
      </div>
      {
        <FormGroup row={true}>
          <RadioGroup
            aria-label="response"
            name="response"
            value={obj.type || ""}
            onChange={handleRadioChange(obj.response_seq)}
          >
            <FormControlLabel
              value="noted"
              control={<Radio />}
              label="Noted and not my group to reply"
            />
            <FormControlLabel
              value="nocomment"
              control={<Radio />}
              label="No advise comment"
            />
            <FormControlLabel
              value="givecomment"
              control={<Radio />}
              label="Give comment"
            />
          </RadioGroup>
        </FormGroup>
      }
      {obj.type === "givecomment" && (
        <>
          <Grid item xs={12}>
            <div className={classes.fileUploadBtnArea}>
              <Legend id="attachment" label="ATTACHMENT">
                <Box className={classes.addFileBtnArea}>
                  <FileDropzone
                    key={"rfi_attachment"}
                    title={""}
                    fileType={"rfi_attachment"}
                    disabled={false}
                    response_seq={response_seq}
                    presetDraftResponseFiles={presetDraftResponseFiles}
                    fileUploadAction={draftResponseFileUploadAction}
                    fileRemoveAction={removeDraftResponseFileConfirmAction}
                    viewFileAction={viewFileAction}
                    DropzoneContent={RFIDraftResponseFileZoneContent}
                    openFileManagerDialog={() => {
                      openFileManagerDialog(response_seq);
                    }}
                  />
                </Box>
              </Legend>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Legend id="content" label="CONTENT">
            <CKEditor
              editor={ClassicEditor}
              data={obj.response || ""}
              name={"response"}
              onChange={ckeditorHandleChange(obj.response_seq)}
              config={editorConfiguration}
            />
          </Legend>
        </>
      )}
      <Grid item xs={12}>
        <TextField
          required
          className={classes.textField}
          fullWidth={true}
          id="from"
          label="From"
          margin="normal"
          variant="outlined"
          name="from"
          type="text"
          size="small"
          variant="outlined"
          value={obj.from || ""}
          onChange={handleResponseInputChange("from", obj.response_seq)}
          error={
            validateError.postFlag &&
            validateError.from &&
            validateError.from !== ""
              ? true
              : false
          }
          helperText={validateError.from}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          required
          className={classes.textField}
          fullWidth={true}
          id="companyName"
          label="Company Name"
          margin="normal"
          variant="outlined"
          name="companyName"
          type="text"
          size="small"
          variant="outlined"
          value={obj.companyName || ""}
          onChange={handleResponseInputChange("companyName", obj.response_seq)}
          error={
            validateError.postFlag &&
            validateError.companyName &&
            validateError.companyName !== ""
              ? true
              : false
          }
          helperText={validateError.companyName}
        />
      </Grid>
      <Grid>
        <TextField
          id="response_date"
          style={{ width: "100%" }}
          //   defaultValue={new Date().toISOString().slice(0, 10)}
          value={obj.responded_date}
          label="Date"
          InputProps={{
            readOnly: true,
          }}
          variant="outlined"
        />
      </Grid>
      <Grid container spacing={1}>
        <div className={classes.rfibtnGroup}>
          <Button
            variant="contained"
            color="primary"
            className={classes.formBtn}
            onClick={() => {
              saveDraftResponsetoDraftAction(rfi_seq, obj.response_seq);
            }}
          >
            Save Only
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.formBtn}
            onClick={() => {
              setValidateError({ ...validateError, postFlag: true });
              postDraftResponseConfirmAction(
                rfi_seq,
                obj.response_seq,
                validateError
              );
            }}
          >
            Send
          </Button>
        </div>
        <Divider className={classes.divider} />
      </Grid>
    </Fragment>
  );
};

export default RFIDraftResponseItem;
